import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { combineLatest, distinctUntilChanged, map, Observable, Subject, Subscription, takeUntil } from 'rxjs';

import { ApiloaderService } from './apiloader.service';

interface ApiStatus {
  offline: boolean;
  apiDown: boolean;
  loading: boolean;
}

@Component({
  selector: 'app-apiloader',
  templateUrl: './apiloaderwidget.component.html',
  styleUrls: ['./apiloaderwidget.component.scss'],
  imports:[CommonModule],
  standalone: true
})
export class ApiloaderWidgetComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  readonly apiStatus$: Observable<ApiStatus> = combineLatest([
    this.apiLoaderService.isOffline,
    this.apiLoaderService.isAPIOffline,
    this.apiLoaderService.loading$
  ]).pipe(
    takeUntil(this.destroy$),
    map(([offline, apiDown, loading]) => ({ offline, apiDown, loading })),
    distinctUntilChanged((a, b) =>
      a.offline === b.offline &&
      a.apiDown === b.apiDown &&
      a.loading === b.loading
    )
  );

  private subscriptions: Subscription[];

  constructor(public apiLoaderService: ApiloaderService) {
    //const loaderService = this.loaderService;
    //this.loading$ = loaderService.isLoading.asObservable();
  }

  ngOnInit(): void {
    //this.subscriptions.push(this.apiLoaderService.isloading$.subscribe(arg => this.isLoading = arg));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    //this.subscriptions.forEach(s => s.unsubscribe());
  }
}
